import React from 'react';
import CandidatesDetails from 'components/candidates/Details';
import MatchesDetails from 'components/matches/Details';
import {Button} from 'react-bootstrap'

export default props => {
  return (
    <div>
      <Button bsStyle="danger" className="pull-right" onClick={props.selectOne()}>Close</Button>
      <h2>Indepth: Match</h2>
      <MatchesDetails {...props} />
      {/* <CandidatesDetails.Container candidateId={props.selected._candidate} /> */}
      {/* <CompaniesDetails.Container recruiterId={props.selected._company} /> */}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/matches/Indepth.jsx